import {FC} from 'react'
import {useNavigate} from 'react-router-dom'
import {useBreadcrumb} from '../../hooks/useBreadcrumb'

const Breadcrumb: FC = () => {
  const {breadcrumbs} = useBreadcrumb()
  const navigate = useNavigate()

  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null
  }

  const handleClick = (e: React.MouseEvent, path: string): void => {
    e.preventDefault()
    navigate(path)
  }

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb m-0">
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1
          const path = item.url || item.path || ''

          return (
            <li
              key={item.url || item.label}
              className={`breadcrumb-item ${isLast ? 'active' : ''}`}
              {...(isLast && {'aria-current': 'page'})}
            >
              {isLast || (!item.url && !item.path) ? (
                <span>{item.label}</span>
              ) : (
                <a
                  href={path}
                  className="text-decoration-none"
                  onClick={(e) => handleClick(e, path)}
                >
                  {item.label}
                </a>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumb
